import { Injectable, inject } from '@angular/core';
import { PopupComponent } from '../popup/popup.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable( {
  providedIn: 'root',
} )
export class ShowPopupService {
  private dialog = inject(MatDialog);

  constructor() {}

  showPopup( options: {
    status: 'isSuccess' | 'failure' | 'warning' | 'information',
    translationKey: string,
    title?: string,
    message?: string
    isBackToLogin?: boolean,
  } ): void {
    this.dialog.open( PopupComponent, {
      data: {
        ...options,
      },
    } );
  }

  showSuccessPopup( options: {
    translationKey?: string,
    title?: string,
    message?: string
  } ): void {
    this.dialog.open( PopupComponent, {
      data: {
        ...options,
      },
    } );
  }

  showFailurePopup( options: {
    translationKey?: string;
    title?: string;
    message?: string;
    isBackToLogin?: boolean;
  } ): void {
    this.dialog.open( PopupComponent, {
      disableClose: options.isBackToLogin ?? false,
      data: {
        ...options,
      },
    } );
  }

  showConfirmationPopup( options: {
    status: 'isSuccess' | 'failure' | 'warning' | 'information',
    translationKey: string,
    title?: string,
    message?: string
    isBackToLogin?: boolean,
  } ) {
    return this.dialog.open( PopupComponent, {
      data: {
        ...options,
        isConfirmation: true,
      },
    } ).afterClosed();
  }
}
